import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UxService } from '~/app/core/services';
import { RoleService } from '~/app/open-age/core/services';
import { InsightApiBase } from './insight-api.base';

@Injectable()
export class WidgetDataService extends InsightApiBase<any> {
  constructor(
    http: HttpClient, roleService: RoleService, uxService: UxService
  ) {
    super('reportTypes/data', http, roleService, uxService);
  }
}
